// extracted by mini-css-extract-plugin
module.exports = {"mobile":"414px","tablet":"768px","laptop":"1280px","desktop":"1600px","largedesktop":"2100px","full":"2400px","currencyIcon":"styles_currencyIcon__6pC8K"};